
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-cancellation-modal',
    templateUrl: './cancellation-modal.component.html',
    styleUrls: ['./cancellation-modal.component.scss'],
    standalone: false
})
export class CancellationModalComponent  {
  @Input() modalData: any;

  constructor(public readonly activeModal: NgbActiveModal) {}

  confirm(status: boolean) {
    this.activeModal.close({ status });
  }
 
}

